import { Outlet } from "react-router-dom";
import { AppProviders } from "./providers/app-providers";

export default function App() {
  return (
    <AppProviders>
      <Outlet />
    </AppProviders>
  );
}
